/**
 * Copyright (c) 2019 2020 2021 2022 AIGIA. All Rights Reserved.
 * see license.txt
 */

"use strict";

import {Callback, IErrorObject} from "../../../../../types/platform/universe";

import {AfterViewInit, Component, ElementRef, Inject, OnInit, ViewChild} from "@angular/core";
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from "@angular/material/dialog";
import {TranslateService} from "@ngx-translate/core";
import {GuestsService} from "../../guests/guests.service";
import {SessionService} from "../../../platform/base/services/session.service";
import {Overlay} from "@angular/cdk/overlay";
import {MatSnackBar} from "@angular/material/snack-bar";
import {MessageDialogComponent} from "../../base/components/message-dialog/message-dialog.component";
import {environment} from "../../../../environments/environment";
import {YesNoDialogComponent} from "../../../platform/base/components/yes-no-dialog/yes-no-dialog.component";
import {ActivatedRoute, Router} from "@angular/router";
import {BelongsPanelComponent} from "../belongs-panel/belongs-panel.component";
import {BaseDialogComponent} from "../../../platform/base/components/base-dialog.component";

/**
 *
 *
 * @since 0.01
 */
@Component({
	selector: "belongs-dialog",
	styleUrls: ["./belongs-dialog.component.css"],
	templateUrl: "./belongs-dialog.component.html",
})

export class BelongsDialogComponent extends BaseDialogComponent implements OnInit, AfterViewInit {

	// dialog_content
	@ViewChild('dialog_content') dialogContent: ElementRef;
	@ViewChild('belongs_panel') belongsPanel: BelongsPanelComponent;

	public auth: number;
	public type: string;
	public nickname: string;
	public username: string;
	public company_url: string = "";
	public studio_url: string = "";

	public selected_manages: any[] = [];
	public manages: any[] = [];
	public manage: any;
	public selected_companies: any[] = [];
	public companies: any[] = [];
	public company: any;
	public selected_studios: any[] = [];
	public studios: any[] = [];
	public studio: any;
	public selected_trainers: any[] = [];
	public trainers: any[] = [];
	public trainer: any;

	public selected_users: any[] = [];

	public account: any;
	public user_id: string = "";

	public delete_enable: boolean = false;

	private params: any = {};

	private user_url: boolean;
	private default_username: string;
	private hashed_names: { company: string, studio: string, trainer: string } = {company: "", studio: "", trainer: ""};


	//private progress: boolean;

	/**
	 * @param data
	 * @param matDialogRef
	 * @param session
	 * @param overlay
	 * @param accountService
	 * @param matDialog
	 * @param snackbar
	 * @param router
	 * @param route
	 * @param translate
	 */
	constructor(
		@Inject(MAT_DIALOG_DATA)
		public data: any,
		public matDialogRef: MatDialogRef<BelongsDialogComponent>,
		protected session: SessionService,
		protected overlay: Overlay,
		protected accountService: GuestsService,
		protected matDialog: MatDialog,
		protected snackbar: MatSnackBar,
		protected router: Router,
		protected route: ActivatedRoute,
		public translate: TranslateService
	) {
		super();
	}

	/**
	 * todo
	 */
	public union(arrays: any[][]): any[] {
		const set_array: any[] = [];
		arrays.forEach((array: any[]): void => {
			set_array.push(...array);
		})
		// return [...new Set(set_array)];
		return Array.from(new Set(set_array));
	}

	/**
	 * todo
	 */
	public ngAfterViewInit(): void {
		this.dialogContent.nativeElement.addEventListener("keydown", (event: any) => {
			if (event.key === "Shift") {
				this.delete_enable = true;
			}
		});

		this.dialogContent.nativeElement.addEventListener("keyup", (event: any) => {
			if (event.key === "Shift") {
				this.delete_enable = false;
			}
		});
	}

	/**
	 * @returns none
	 */
	public ngOnInit(): void {

		this.manages = [environment.default];
		this.default_username = environment.default.username;

		this.auth = this.data.auth;
		this.account = this.data.account;
		this.type = this.account.type;
		this.username = this.account.username;
		this.nickname = this.account.nickname;

		this.route.queryParams.subscribe(params => {
			this.params = params;
			if (this.params.i) {
				this.user_id = decodeURIComponent(this.params.i);
			}
			if (this.params.c) {
				this.hashed_names.company = decodeURIComponent(this.params.c);
				if (this.params.s) {
					this.hashed_names.studio = decodeURIComponent(this.params.s);
					if (this.params.t) {
						this.hashed_names.trainer = decodeURIComponent(this.params.t);
					}
				}
				this.user_url = true;
			} else {
				this.user_url = false;
			}
			this.draw();
		});
	}

	/**
	 * @returns none
	 */
	public onAddItem(user: any): void {
		const resultDialogContent: any = {title: "追加", message: "追加しますか?", ok_button: "追加"};
		const dialog: MatDialogRef<any> = this.matDialog.open(YesNoDialogComponent, {
			width: "50%",
			minWidth: "320px",
			height: "fit-content",
			data: {
				//			session: this.currentSession,
				content: resultDialogContent,
			},
			disableClose: true,
		});
		dialog.afterClosed().subscribe((result: object) => {
			if (result) { // if not cancel then
				this.addItem(user);
			}
		});
	}

	/**
	 * @returns none
	 */
	public onRemoveItem(user: any): void {
		const resultDialogContent: any = {title: "削除", message: "削除しますか?", ok_button: "削除"};
		const dialog: MatDialogRef<any> = this.matDialog.open(YesNoDialogComponent, {
			width: "50%",
			minWidth: "320px",
			height: "fit-content",
			data: {
				//		session: this.currentSession,
				content: resultDialogContent,
			},
			disableClose: true,
		});
		dialog.afterClosed().subscribe((result: object) => {
			if (result) { // if not cancel then
				this.removeItem(user);
			}
		});
	}

	/**
	 * @returns none
	 */
	public onMakeRelation(user_id: string, type: string): void {
		this.makeRelation(user_id, type, (error) => {
			//	this.getUser(this.account?.user_id, (error: IErrorObject, account: any): void => {
			if (!error) {
				this.draw();
			} else {
				this.errorDialog(error);
			}
			//	});
		});
	}

	/**
	 * @returns none
	 */
	public onBreakRelation(to_id: string, type: string): void {
		this.breakRelation(this.account?.user_id, to_id, type, (error) => {
			if (!error) {
				this.draw();
			} else {
				this.errorDialog(error);
			}
		});
	}

	/**
	 * @returns none
	 */
	public onChangeStudio(): void {
		if (this.studio) {
			this.children(this.studio.account.user_id, "trainer", (error, all_trainers) => {  // all trainer
				if (!error) {
					this.hashFilter(all_trainers, this.hashed_names.trainer, (error, trainer) => {
						this.trainers = trainer;
					});
				}
			});
		}
	}

	/**
	 * @returns none
	 */
	public onAccept(): void {
		this.matDialogRef.close(null);
	}

	/**
	 * @returns Promise
	 */
	private async sha256(text: string): Promise<string> {
		const uint8 = new TextEncoder().encode(text)
		const digest = await crypto.subtle.digest('SHA-256', uint8)
		return Array.from(new Uint8Array(digest)).map(v => v.toString(16).padStart(2, '0')).join('');
	}

	/**
	 * @returns none
	 */
	private HashValue(S: string, length: number, callback: Callback<string>): void {
		this.sha256(S).then((hash): void => {
			callback(null, hash.slice(0, length));
		}).catch((error): void => {
			callback(error, null);
		});
	}

	/**
	 * エラーダイアログ
	 *
	 * @returns none
	 */
	private errorDialog(error: IErrorObject, callback: (result: any) => void = (error: IErrorObject) => {}): void {
		if (error) {

			const dialog: MatDialogRef<any> = this.matDialog.open(MessageDialogComponent, {
				width: "30%",
				minWidth: "320px",
				height: "fit-content",
				data: {content: {title: "Error.", message: error.message, tag: error.tag}},
				disableClose: true,
			});

			dialog.afterClosed().subscribe((result: any): void => {
				callback(result);
			});

		}
	}

	/**
	 *
	 * @param hash
	 * @param plain
	 * @param callback
	 */
	private hashEqual(hash: string, plain: string, callback: Callback<boolean>): void {
		this.HashValue(plain, 10, (error, hashed_target) => {
			callback(error, (hashed_target === hash));
		});
	}

	/**
	 * @returns none
	 */
	private nameEqual(accounts: any[], hashed_name: string, callback: Callback<any>): void {
		accounts.forEach((account: { account: any, type: string }) => {
			if (account.account.username) {
				this.hashEqual(hashed_name, account.account.username, (error: any, match: boolean) => {
					if (!error) {
						if (match) {
							callback(null, account);
						} else {
							callback(null, null);
						}
					} else {
						callback(error, null);
					}
				})
			}
		});
	}

	/**
	 * @returns none
	 *
	 * URLに設定があればフィルタリング。
	 * なければ全て。
	 */
	private hashFilter(source: any, hashed_name: string, callback: Callback<any>): void {
		let result = source;
		if (hashed_name) {
			this.nameEqual(source, hashed_name, (error: IErrorObject, equals: any) => {
				if (!error) {
					if (equals) {
						result = [equals];
						callback(null, result);
					}
				} else {
					callback(error, null);
				}
			});
		} else {
			callback(null, result);
		}
	}

	/**
	 * @returns none
	 */
	private limitedChildren(default_user_id: string, hashed_names: { company: string, studio: string, trainer: string }, callback: Callback<any>): void {
		this.children(default_user_id, "company", (error, all_companies) => { // all company
			if (!error) {
				this.hashFilter(all_companies, hashed_names.company, (error, company) => {
					this.companies = company;
					if (this.companies.length > 0) {
						this.children(this.companies[0].account.user_id, "studio", (error, all_studios) => {  // all studio
							if (!error) {
								this.hashFilter(all_studios, hashed_names.studio, (error, studio) => {
									this.studios = studio;
									if (this.studios.length > 0) {
										this.children(this.studios[0].account.user_id, "trainer", (error, all_trainers) => {  // all trainer
											if (!error) {
												this.hashFilter(all_trainers, hashed_names.trainer, (error, trainer) => {
													this.trainers = trainer;
													callback(null, null);
												});
											} else {
												callback(error, null);
											}
										});
									} else {
										callback(null, null);
									}
								});
							} else {
								callback(error, null);
							}
						});
					} else {
						callback(null, null);
					}
				});
			} else {
				callback(error, null);
			}
		});
	}

	/**
	 * @returns none
	 */
	private allRelation(callback: Callback<any>): void {
		this.all("company", (error, all_companies) => { // all company
			if (!error) {
				this.companies = all_companies;
				this.all("studio", (error, all_studios) => {  // all studio
					if (!error) {
						this.studios = all_studios;
						this.all("trainer", (error, all_trainers) => {  // all trainer
							if (!error) {
								this.trainers = all_trainers;
								callback(null, null);
							} else {
								callback(error, null);
							}
						});
					} else {
						callback(error, null);
					}
				});
			} else {
				callback(error, null);
			}
		});
	}

	/**
	 * @returns none
	 */
	private hashedNamesUrl(callback: Callback<any>): void {
		this.HashValue(this.username, 10, (error, username_hash) => {
			if (!error) {
				this.company_url = environment.displayServerName + "?" + "c=" + encodeURIComponent(username_hash);
				if (this.selected_companies.length) {
					const first_company = this.selected_companies[0];
					this.HashValue(first_company.account.username, 10, (error, companyname_hash) => {
						if (!error) {
							this.studio_url = environment.displayServerName + "?" + "c=" + encodeURIComponent(companyname_hash) + "&" + "s=" + encodeURIComponent(username_hash);
							callback(null, null);
						} else {
							callback(error, null);
						}
					});
				} else {
					callback(null, null);
				}
			} else {
				callback(error, null);
			}
		});
	}

	/**
	 * todo
	 */
	private selectedRelation(callback: Callback<any>): void {
		this.relationTo("manage", "belongs", (error, manages) => {
			if (!error) {
				this.selected_manages = manages;
				this.relationTo("company", "belongs", (error, companies) => {
					if (!error) {
						this.selected_companies = companies;
						this.relationTo("studio", "belongs", (error, studios) => {
							if (!error) {
								this.selected_studios = studios;
								this.relationTo("trainer", "belongs", (error, trainers) => {
									if (!error) {
										this.selected_trainers = trainers;
										this.relationTo("", "belongs", (error, users) => {
											if (!error) {
												this.selected_users = users;
												this.hashedNamesUrl((error, value) => {
													if (!error) {
														callback(null, null);
													} else {
														callback(null, null);
													}
												});
											} else {
												callback(null, null);
											}
										});
									} else {
										callback(null, null);
									}
								});
							} else {
								callback(error, null);
							}
						});
					} else {
						callback(null, null);
					}
				});
			} else {
				callback(null, null);
			}
		});
	}

	/**
	 * todo
	 */
	private limitedHierarchy(default_username: string, hashed_names: { company: string, studio: string, trainer: string }, callback: Callback<any>): void {
		this.accountService.get_user_by_name(default_username, (error: IErrorObject, account: any): void => {
			if (!error) {
				const default_user_id = account.user_id;
				this.manages[0].user_id = account.user_id; // default manage account user_id.
				this.limitedChildren(default_user_id, hashed_names, (error, value) => {
					if (!error) {
						this.selectedRelation((error, value) => {
							if (!error) {
								callback(null, value);
							} else {
								callback(error, null);
							}
						});
					} else {
						callback(error, null);
					}
				});
			} else {
				callback(error, null);
			}
		});
	}

	/**
	 * todo
	 */
	private openHierarchy(default_username: string, callback: Callback<any>): void {
		this.accountService.get_user_by_name(default_username, (error: IErrorObject, account: any): void => {
			if (!error) {
				this.manages[0].user_id = account.user_id; // default manage account user_id.
				this.allRelation(() => {
					if (!error) {
						this.selectedRelation((error, value) => {
							if (!error) {
								callback(null, value);
							} else {
								callback(error, null);
							}
						});
					} else {
						callback(error, null);
					}
				});
			} else {
				callback(error, null);
			}
		});
	}

	/**
	 * @returns none
	 */
	private draw(): void {
		if (this.user_url) {
			this.limitedHierarchy(this.default_username, this.hashed_names, (error, value) => {
				if (!error) {
					this.belongsPanel.onUpdate();
				} else {
					this.errorDialog(error);
				}
			});
		} else {
			this.openHierarchy(this.default_username, (error, value) => {
				if (!error) {
					this.belongsPanel.onUpdate();
				} else {
					this.errorDialog(error);
				}
			});
		}
	}

	/**
	 * @returns none
	 */
	private addItem(user: any): void {
		this.onMakeRelation(user.user_id, "belongs");
	}

	/**
	 * @returns none
	 */
	private removeItem(user: any): void {
		this.onBreakRelation(user.user_id, "belongs");
	}

	/**
	 * @returns none
	 */
	private all(type: string, callback: Callback<any>): void {
		this.accountService.all_relation(type, "belongs", {}, (error, accounts: { account: any, enabled: boolean, from_id: any, to_id: any, type: string }[]) => {
			if (!error) {
				callback(null, accounts);
			} else {
				callback(error, null);
			}
		});
	}

	/**
	 * @returns none
	 */
	private children(user_id: string, type: string, callback: Callback<any>): void {
		this.accountService.relation_from_user_with_type(user_id, type, "belongs", {}, (error, accounts: { account: any, enabled: boolean, from_id: any, to_id: any, type: string }[]) => {
			if (!error) {
				callback(null, accounts);
			} else {
				callback(error, null);
			}
		});
	}

	/**
	 * リレーション
	 * @param to_id
	 * @param type
	 * @param callback
	 */
	private makeRelation(to_id: string, type: string, callback: Callback<object>): void {
		this.Progress(true);
		this.accountService.make_relation(this.account?.user_id, to_id, type, (error: IErrorObject, result: object): void => {
			if (!error) {
				callback(null, result);
			} else {
				callback(error, null);
			}
			this.Progress(false);
		});
	}

	/**
	 * リレーション削除
	 * @param user_id
	 * @param to_id
	 * @param type
	 * @param callback
	 */
	private breakRelation(user_id: string, to_id: string, type: string, callback: Callback<object>): void {
		this.Progress(true);
		this.accountService.break_relation(user_id, to_id, type, (error: IErrorObject, result: object): void => {
			if (!error) {
				callback(null, result);
			} else {
				callback(error, null);
			}
			this.Progress(false);
		});
	}

	/**
	 * @returns none
	 */
	private relationTo(target_type: string, relation_type: string, callback: Callback<any>): void {
		const result: any[] = [];
		this.accountService.relation_to(this.account?.user_id, relation_type, {}, (error, results) => {
			if (!error) {
				results.forEach((user: any) => {
					if (user.account?.type === target_type) {
						result.push(user);
					}
				})
				callback(null, result);
			} else {
				callback(error, null);
			}
		});
	}

}
